import { api } from './client.js';

const root = '/admin/api-clients';

export const apiClientsApi = {
  list: (params) => api.get(root, { query: params }),
  get: (id) => api.get(`${root}/${id}`),
  create: (body) => api.post(root, body),
  update: (id, body) => api.patch(`${root}/${id}`, body),
  rotateSecret: (id) => api.post(`${root}/${id}/rotate-secret`),
  revoke: (id) => api.post(`${root}/${id}/revoke`),
  remove: (id) => api.delete(`${root}/${id}`)
};
